import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ColumnGroup } from 'react-table';

import i18next from 'i18next';

export const useColumns = (date: string) => {
  const { t } = useTranslation();

  return useMemo(
    (): ColumnGroup[] => [
      {
        Header: 'Budgets',
        columns: [
          {
            Header: t('statistics.marketing')!,
            accessor: 'marketing',
          },
          {
            Header: t('budget.prevSold')!,
            accessor: 'prevSold',
          },
          {
            Header: t('product.sold')!,
            accessor: 'currSold',
          },
          {
            Header: `To do ${date}`,
            accessor: 'currQuantity',
          },
          {
            Header: t('statistics.forecast')!,
            accessor: 'forecast',
            Cell: ({ row }) => (
              <span>{row.original.currQuantity + row.original.currSold}</span>
            ),
          },
        ],
      },
    ],
    [i18next.language, date]
  );
};
